import { Grid, Paper } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { selectIsClient, selectUserClientAccountId } from "features/user/userSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomReport from "../CustomReport";
import FormBuilder from "../formBuilder";
import { formTypeOptions } from "../formBuilder/formBuilderConsts";
import { setClientAccountId,setClientId, setFormType } from "./formStateSlice";
import { FormListStyle } from "./style";

const FormList = ({ }) => {
    const classes = FormListStyle();
    const isClient = useSelector(selectIsClient);
    const currentClientAccountId = useSelector(selectUserClientAccountId);
    const { clientAccountId, clientId, formType } = useSelector(state => state.formState);

    const dispatch = useDispatch()


    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null, { skip: isClient });

    const accounts = clients?.flatMap(c => c.clientAccounts);
    
    useEffect(() => {
        if (isClient) {
            dispatch(setClientAccountId(currentClientAccountId))
            var currentClientId = accounts?.find(c => c.id === currentClientAccountId)?.id;
            dispatch(setClientId(currentClientId))
        }
    }, [])

    const onClientChange = (val) => {
        var currentClientAccountId = accounts?.find(c => c.clientId == val)?.id;
        dispatch(setClientId(val))
        dispatch(setClientAccountId(currentClientAccountId));
    }

    const tabs = [
        {
            label: 'Form',
            component: <FormBuilder />
        },
        {
            label: 'Custom Report',
            component: <CustomReport />
        }
    ]

    return (
        <Grid container direction="column">
            <Paper className={classes.formListFilters}>
                <Grid container spacing={2}>
                    {!isClient && <Grid item xs={6} container direction="column" >
                        <Grid item className={classes.filterLabel}>Select Client</Grid>
                        <Grid item >
                            <CustomInput
                                id="clientId"
                                value={clientId}
                                elementType="dropdown"
                                onChange={val => {
                                    onClientChange(+val);
                                }}
                                values={clients}
                                showEmpty
                                placeholder={'Select client'}
                            />
                        </Grid>
                    </Grid>}
                    <Grid item xs={6} container direction="column">
                        <Grid item className={classes.filterLabel}>Select Form Type</Grid>
                        <Grid item >
                            <CustomInput
                                id="formType"
                                value={formType}
                                elementType="dropdown"
                                onChange={val => {
                                    dispatch(setFormType(+val));
                                }}
                                values={formTypeOptions}
                                showEmpty
                                placeholder={'Select form type'}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <div className={classes.formBuilderContainer}>
                {(!clientAccountId || !formType) && <EmptyPlaceholder
                    text="Please select client and form type"
                />}
                {!!clientAccountId && !!formType && <>
                    {/* {Object.values(formTypes).map(formType =>
                    <div>
                        {formType}
                        {formByTypeMap?.[formType]?.name}
                    </div>)} */}
                    <TabsWrapper tabs={tabs} />
                </>}
            </div>
        </Grid>
    )
}
export default FormList;